import { PageTitle } from "../shared";
import { PageNotImplemented } from "../";

export const HowTo = () => (
  <>
    <PageTitle title={"How to Use AuthZ Data Manager"} />
    <PageNotImplemented title={""} />
  </>
)
